import styled from "styled-components"

const Container = styled.div`
  width: 1080px;
  margin: 0 auto;
`

export default Container
